import { Action } from '@ngrx/store';

export enum signupActionTypes {
    DO_RESET = '[Signup] Reset',
    DO_SIGNUP = '[Signup] Do Signup',
    DO_SIGNUP_SUCCESS = '[Signup] Do Signup Success',
    DO_SIGNUP_FAIL = '[Signup] Do Signup Fail'
}


export class DoReset implements Action {
    readonly type = signupActionTypes.DO_RESET;
    constructor() { }
}


export class DoSignup implements Action {
    readonly type = signupActionTypes.DO_SIGNUP;
    constructor(public payload: any) { }
}


export class DoSignupSuccess implements Action {
    readonly type = signupActionTypes.DO_SIGNUP_SUCCESS;
    constructor(public payload: any) { }
}


export class DoSignupFail implements Action {
    readonly type = signupActionTypes.DO_SIGNUP_FAIL;
    constructor(public error: number) { }
}


export type signupActions = DoReset | DoSignup | DoSignupSuccess | DoSignupFail;
